import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { handleErrorNotification } from 'Common/utils';
import { useApiClient } from '../../utils/apiClient';

/* eslint-disable import/prefer-default-export */

export const useLoadDepExport = () => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.Rksv.loadDepExport,
    onSuccess: (data) => {
      queryClient.setQueryData(['rksv', 'depexport'], data);
    },
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};
